(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elaine-account-menu"] && !Shopify.designMode) return;
  try {
    class ElaineAccountMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.elaine-account__trigger');
      this.panel = this.querySelector('.elaine-account__panel');
      if (!this.trigger || !this.panel) return;

      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    toggle() {
      this.panel.hidden ? this.open() : this.close();
    }

    open() {
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (this.panel.hidden) return;
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('elaine-account-menu')) {
    customElements.define('elaine-account-menu', ElaineAccountMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["welcome-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var hoja = document.getElementById('elaineWelcomePopup');
    var pestana = document.getElementById('elaineBienvenidaPestana');
    if (!hoja || typeof hoja.showModal !== 'function') return;

    var CERRADA = 'elaine_welcome_popup_dismissed';
    var PESTANA_FUERA = 'elaine_bienvenida_pestana_fuera';
    var SUSCRITA = 'elaine_bienvenida_suscrita';
    var TREINTA_DIAS = 30 * 24 * 60 * 60 * 1000;
    var lee = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
    var guarda = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var marca = hoja.querySelector('[data-exito]');
    var exito = !!marca && marca.getAttribute('data-exito') === 'si';
    var mostrada = false;

    function abrir() {
      if (hoja.open) return;
      hoja.showModal();
      hoja.setAttribute('tabindex', '-1');
      hoja.focus({ preventScroll: true });
      mostrada = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { hoja.classList.add('ec-bv--dentro'); }); });
    }
    function cerrar() {
      guarda(CERRADA, String(Date.now()));
      hoja.classList.remove('ec-bv--dentro');
      if (reducido) { hoja.close(); return; }
      var fin = function () { hoja.close(); hoja.removeEventListener('transitionend', fin); };
      hoja.addEventListener('transitionend', fin);
      setTimeout(function () { if (hoja.open) hoja.close(); }, 400);
    }

    hoja.querySelectorAll('[data-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    hoja.addEventListener('cancel', function (e) { e.preventDefault(); cerrar(); });
    hoja.addEventListener('click', function (e) { if (e.target === hoja) cerrar(); });

    var copiar = hoja.querySelector('[data-copiar]');
    if (copiar) copiar.addEventListener('click', function () {
      var codigo = document.getElementById('ecBvCodigo').textContent.trim();
      var listo = function () { copiar.textContent = 'Copiado'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(listo, function () { window.getSelection().selectAllChildren(document.getElementById('ecBvCodigo')); });
      } else { window.getSelection().selectAllChildren(document.getElementById('ecBvCodigo')); }
    });

    var y0 = null;
    hoja.addEventListener('touchstart', function (e) { if (hoja.scrollTop <= 0) y0 = e.touches[0].clientY; }, { passive: true });
    hoja.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      hoja.style.transition = 'none';
      hoja.style.transform = 'translateY(' + Math.max(0, e.touches[0].clientY - y0) + 'px)';
    }, { passive: true });
    hoja.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var d = e.changedTouches[0].clientY - y0; y0 = null;
      hoja.style.transition = ''; hoja.style.transform = '';
      if (d > 96) cerrar();
    });

    if (exito) {
      guarda(SUSCRITA, '1');
      abrir();
      return;
    }
    if (lee(SUSCRITA) || lee(CERRADA)) return;

    var fuera = Number(lee(PESTANA_FUERA) || 0);
    if (pestana && Date.now() - fuera > TREINTA_DIAS) {
      pestana.hidden = false;
      pestana.querySelector('.ec-bv-pestana__abrir').addEventListener('click', abrir);
      pestana.querySelector('.ec-bv-pestana__cerrar').addEventListener('click', function () {
        pestana.hidden = true; guarda(PESTANA_FUERA, String(Date.now()));
      });
    }

    function navOcupado() { return !!document.querySelector('header-menu [aria-expanded="true"], .menu-drawer[open], details[open] > .menu-drawer'); }
    function intenta() {
      if (mostrada || lee(CERRADA)) return;
      if (navOcupado()) { setTimeout(intenta, 5000); return; }
      abrir();
    }
    setTimeout(intenta, 20000);
    function alBajar() {
      var avance = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (avance >= 0.5) { window.removeEventListener('scroll', alBajar); intenta(); }
    }
    window.addEventListener('scroll', alBajar, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
